import { useTranslation } from 'react-i18next';
import type { IStockEntryDialogProps } from './StockEntryDialog.types';
import { FormDialogShell } from './FormDialogShell';
import { StockEntryForm } from './StockEntryForm';
import styles from './StockEntryDialog.module.css';

export type { IStockPrefill } from './StockEntryDialog.types';

/**
 * The modal surface for the stock form — chrome only (`FormDialogShell`, the
 * same shell the delivery-order dialog wears). The fields, validation and the
 * save mutation live in `StockEntryForm`, which the StockDetailDrawer's Edit
 * tab renders too (one form, two surfaces — the same split the delivery
 * order form has). The form mounts INSIDE the popup, so Base UI's post-close
 * unmount resets it and every open starts from the current prefill.
 */
export function StockEntryDialog({ open, onClose, mode, ...form }: IStockEntryDialogProps) {
  const { t } = useTranslation();
  return (
    <FormDialogShell
      open={open}
      onClose={onClose}
      title={t(mode === 'sync' ? 'logistics.stockDialog.titleSync' : 'logistics.stockDialog.title')}
      cancelLabel={t('logistics.stockDialog.cancel')}
      classes={styles}
    >
      {(cancel) => <StockEntryForm {...form} mode={mode} onClose={onClose} secondaryAction={cancel} />}
    </FormDialogShell>
  );
}
